"use strict";

var _toConsumableArray = require("/home/runner/work/recipebook/recipebook/node_modules/@babel/runtime/helpers/toConsumableArray.js");

var _inherits = require("/home/runner/work/recipebook/recipebook/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/home/runner/work/recipebook/recipebook/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/home/runner/work/recipebook/recipebook/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

var _createClass = require("/home/runner/work/recipebook/recipebook/node_modules/@babel/runtime/helpers/createClass.js");

var _classCallCheck = require("/home/runner/work/recipebook/recipebook/node_modules/@babel/runtime/helpers/classCallCheck.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Metadata = exports.Timer = exports.Cookware = exports.Ingredient = exports.Step = exports.Recipe = void 0;
var COMMENT_REGEX = /(--.*)|(\[-(.|\n)+?-\])/g;
var INGREDIENT_REGEX = /@(?:([^@#~]+?)(?:{(.*?)}|{\s*}))|@((?:[^@#~\s])+)/;
var COOKWARE_REGEX = /#(?:([^@#~]+?)(?:{\s*}))|#((?:[^@#~\s])+)/;
var TIMER_REGEX = /~([^@#~]*){([0-9]+(?:[\/|\.][0-9]+)?)%(.+?)}/;
var METADATA_REGEX = /^>>\s*(.*?):\s*(.*)$/; // a base class containing the raw string

var base = /*#__PURE__*/_createClass(function base(s) {
  _classCallCheck(this, base);

  if (s instanceof Array) this.raw = s[0];else if (typeof s === 'string') this.raw = s;else if ('raw' in s) this.raw = s.raw;
});

var Recipe = /*#__PURE__*/function (_base) {
  _inherits(Recipe, _base);

  var _super = _createSuper(Recipe);

  function Recipe(s) {
    var _this;

    _classCallCheck(this, Recipe);

    var _a, _b;

    _this = _super.call(this, s);
    _this.metadata = [];
    _this.ingredients = [];
    _this.cookware = [];
    _this.timers = [];
    _this.steps = [];
    (_b = (_a = s === null || s === void 0 ? void 0 : s.replace(COMMENT_REGEX, '')) === null || _a === void 0 ? void 0 : _a.split('\n')) === null || _b === void 0 ? void 0 : _b.forEach(function (line) {
      if (line.trim()) {
        var l = new Step(line);

        if (l.line.length != 0) {
          if (l.line.length == 1 && l.line[0] instanceof Metadata) {
            _this.metadata.push(l.line[0]);
          } else {
            l.line.forEach(function (b) {
              if (b instanceof Ingredient) _this.ingredients.push(b);else if (b instanceof Cookware) _this.cookware.push(b);else if (b instanceof Timer) _this.timers.push(b);
            });

            _this.steps.push(l);
          }
        }
      }
    });
    return _this;
  }

  _createClass(Recipe, [{
    key: "calculateTotalTime",
    value: function calculateTotalTime() {
      return this.timers.reduce(function (a, b) {
        return a + (b.seconds || 0);
      }, 0);
    }
  }]);

  return Recipe;
}(base);

exports.Recipe = Recipe; // a single recipe step

var Step = /*#__PURE__*/function (_base2) {
  _inherits(Step, _base2);

  var _super2 = _createSuper(Step);

  function Step(s) {
    var _this2;

    _classCallCheck(this, Step);

    _this2 = _super2.call(this, s);
    _this2.line = [];
    if (s && typeof s === 'string') _this2.line = _this2.parseLine(s);else if (s) {
      if ('line' in s) _this2.line = s.line;
      if ('image' in s) _this2.image = s.image;
    }
    return _this2;
  } // parse a single line


  _createClass(Step, [{
    key: "parseLine",
    value: function parseLine(s) {
      var match;
      var b;
      var line = []; // if it's a metadata line, return that

      if (match = METADATA_REGEX.exec(s)) {
        return [new Metadata(match)];
      } // if it has an ingredient, pull that out
      else if (match = INGREDIENT_REGEX.exec(s)) {
        b = new Ingredient(match);
      } // if it has an item of cookware, pull that out
      else if (match = COOKWARE_REGEX.exec(s)) {
        b = new Cookware(match);
      } // if it has a timer, pull that out
      else if (match = TIMER_REGEX.exec(s)) {
        b = new Timer(match);
      } // if we found something (ingredient, cookware, timer)


      if (b && b.raw) {
        // split the string up to get the string left and right of what we found
        var split = s.split(b.raw); // if the line doesn't start with what we matched, we need to parse the left side

        if (!s.startsWith(b.raw)) line.unshift.apply(line, _toConsumableArray(this.parseLine(split[0]))); // add what we matched in the middle

        line.push(b); // if the line doesn't end with what we matched, we need to parse the right side

        if (!s.endsWith(b.raw)) line.push.apply(line, _toConsumableArray(this.parseLine(split[1])));
        return line;
      } // if it doesn't match any regular expressions, just return the whole string


      return [s];
    }
  }]);

  return Step;
}(base);

exports.Step = Step; // ingredients

var Ingredient = /*#__PURE__*/function (_base3) {
  _inherits(Ingredient, _base3);

  var _super3 = _createSuper(Ingredient);

  function Ingredient(s) {
    var _this3;

    _classCallCheck(this, Ingredient);

    var _a;

    _this3 = _super3.call(this, s);

    if (s instanceof Array || typeof s === 'string') {
      var match = s instanceof Array ? s : INGREDIENT_REGEX.exec(s);
      if (!match || match.length != 4) throw "error parsing ingredient: '".concat(s, "'");
      _this3.name = (match[1] || match[3]).trim();
      var attrs = (_a = match[2]) === null || _a === void 0 ? void 0 : _a.split('%');
      _this3.amount = attrs && attrs.length > 0 ? attrs[0].trim() : "1";
      if (!_this3.amount) _this3.amount = "1";
      _this3.quantity = _this3.amount ? stringToNumber(_this3.amount) : 1;
      _this3.units = attrs && attrs.length > 1 ? attrs[1].trim() : "";
    } else {
      if ('name' in s) _this3.name = s.name;
      if ('amount' in s) _this3.amount = s.amount;
      if ('quantity' in s) _this3.quantity = s.quantity;
      if ('units' in s) _this3.units = s.units;
    }

    return _this3;
  }

  return _createClass(Ingredient);
}(base);

exports.Ingredient = Ingredient; // cookware

var Cookware = /*#__PURE__*/function (_base4) {
  _inherits(Cookware, _base4);

  var _super4 = _createSuper(Cookware);

  function Cookware(s) {
    var _this4;

    _classCallCheck(this, Cookware);

    _this4 = _super4.call(this, s);

    if (s instanceof Array || typeof s === 'string') {
      var match = s instanceof Array ? s : COOKWARE_REGEX.exec(s);
      if (!match || match.length != 3) throw "error parsing cookware: '".concat(s, "'");
      _this4.name = (match[1] || match[2]).trim();
    } else {
      if ('name' in s) _this4.name = s.name;
    }

    return _this4;
  }

  return _createClass(Cookware);
}(base);

exports.Cookware = Cookware; // timer

var Timer = /*#__PURE__*/function (_base5) {
  _inherits(Timer, _base5);

  var _super5 = _createSuper(Timer);

  function Timer(s) {
    var _this5;

    _classCallCheck(this, Timer);

    _this5 = _super5.call(this, s);

    if (s instanceof Array || typeof s === 'string') {
      var match = s instanceof Array ? s : TIMER_REGEX.exec(s);
      if (!match || match.length != 4) throw "error parsing timer: '".concat(s, "'");
      _this5.name = match[1] ? match[1].trim() : "";
      _this5.amount = match[2] ? match[2].trim() : 0;
      _this5.units = match[3] ? match[3].trim() : "";
      _this5.quantity = _this5.amount ? stringToNumber(_this5.amount) : 0;
      _this5.seconds = Timer.getSeconds(_this5.quantity, _this5.units);
    } else {
      if ('name' in s) _this5.name = s.name;
      if ('amount' in s) _this5.amount = s.amount;
      if ('quantity' in s) _this5.quantity = s.quantity;
      if ('units' in s) _this5.units = s.units;
      if ('seconds' in s) _this5.seconds = s.seconds;
    }

    return _this5;
  }

  _createClass(Timer, null, [{
    key: "getSeconds",
    value: function getSeconds(amount) {
      var unit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'm';
      var time = 0;

      if (amount > 0) {
        if (unit.toLowerCase().startsWith('s')) {
          time = amount;
        } else if (unit.toLowerCase().startsWith('m')) {
          time = amount * 60;
        } else if (unit.toLowerCase().startsWith('h')) {
          time = amount * 60 * 60;
        }
      }

      return time;
    }
  }]);

  return Timer;
}(base);

exports.Timer = Timer;

function stringToNumber(s) {
  var amount = 0;
  if (parseFloat(s) + '' == s) amount = parseFloat(s);else if (s.includes('/')) {
    var split = s.split('/');

    if (split.length == 2) {
      var num = parseFloat(split[0].trim());
      var den = parseFloat(split[1].trim());

      if (num + '' == split[0].trim() && den + '' == split[1].trim()) {
        amount = num / den;
      } else amount = NaN;
    }
  } else amount = NaN;
  return amount;
} // metadata


var Metadata = /*#__PURE__*/function (_base6) {
  _inherits(Metadata, _base6);

  var _super6 = _createSuper(Metadata);

  function Metadata(s) {
    var _this6;

    _classCallCheck(this, Metadata);

    _this6 = _super6.call(this, s);

    if (s instanceof Array || typeof s === 'string') {
      var match = s instanceof Array ? s : METADATA_REGEX.exec(s);
      if (!match || match.length != 3) throw "error parsing metadata: '".concat(s, "'");
      _this6.key = match[1].trim();
      _this6.value = match[2].trim();
    } else {
      if ('key' in s) _this6.key = s.key;
      if ('value' in s) _this6.value = s.value;
    }

    return _this6;
  }

  return _createClass(Metadata);
}(base);

exports.Metadata = Metadata;